function loadOktaSign(oktaDomain, oktaClientId, oktaRedirectUri, oktaRequestContext) {
    return new OktaSignIn({
        // Assumes there is an empty element on the page with an id of 'osw-container'
        el: '#widget',
        baseUrl: oktaDomain,
        clientId: oktaClientId,
        //logo: '/content/images/Beon Commerce Logo - Black.svg',

        i18n: {
            en: {
                'primaryauth.title': 'Sign in with your email address',
                'oie.remember': 'Remember me',
                'errors.E0000004': ' Incorrect username or password',
            },
        },

        redirectUri: oktaRedirectUri,
        authParams: {
            pkce: false,
            responseType: ['id_token', 'token'],
        },
        features: {
            idpDiscovery: true,

        },
        idpDiscovery: {
            requestContext: oktaRequestContext,
        },
    });
}

function IsSessionExist(iDPEmailDomainList) {
    signIn.authClient.session.exists()
        .then(function (exists) {
            if (exists) {
                SpinnerSpin();
                gettokenDetails();
            } else {
                signIn.on('afterRender', function (context) {
                    if (context.controller !== 'forgot-password') {
                        return;
                    }
                    var inputElement = document.getElementById('account-recovery-username');
                    inputElement.addEventListener('focusout', function (event) {
                        // Handle the focusout event
                        console.log('Element lost focus');
                        var email = document.getElementById('account-recovery-username').value;
                        var isIDP = isIDPDomain(email, iDPEmailDomainList);
                        if (isIDP) {
                            document.querySelector('[data-se="email-button"]').classList.add('email-disabled');
                        }
                        else {
                            document.querySelector('[data-se="email-button"]').classList.remove('email-disabled');
                        }
                    });
                });
                startUserSignIn();
            }
        });
}

function isIDPDomain(email, iDPEmailDomainList) {
    var emailDomain = email.split('@')[1];
    if (emailDomain == undefined || emailDomain == '' || emailDomain == null) {
        return true;
    }
    return iDPEmailDomainList.includes('@' + emailDomain);
}

function gettokenDetails() {
    console.log('trying to get token from API in existing session');
    signIn.authClient.token.getWithoutPrompt({
        responseType: ['id_token', 'token'], // or array of types
    })
        .then(function (res) {
            var tokens = res.tokens;
            // Do something with tokens, such as
            signIn.authClient.tokenManager.setTokens(tokens);
            var accessTokenField = $("#hiddenAccessTokenField");
            accessTokenField.val(tokens.accessToken.accessToken);
            var form = accessTokenField.parent();
            form.submit();

        })
        .catch(function (err) {
            console.log("Error " + err);
            ClearOktaSessions(err.message);
        });
}

function startUserSignIn() {
    signIn.showSignInToGetTokens({
        scopes: ['openid', 'profile'] // optional
    }).then(function (tokens) {
        signIn.authClient.tokenManager.setTokens(tokens);
        var accessTokenField = $("#hiddenAccessTokenField");
        accessTokenField.val(tokens.accessToken.accessToken);
        var form = accessTokenField.parent();
        form.submit();
        // Store tokens
    }).catch(function (error) {
        console.log("Error " + error);
        ClearOktaSessions(error.message);
    });

}

function logOutFromOkta(redirectUri) {
    //Get okta token from local storage
    var oktaToken = localStorage.getItem('okta-token-storage');
    //If okta access token is present in localstorage then we will clear okta access token else will only clear server side session details
    if (oktaToken != null) {

        // localstorage maintains the idToken. This clear() removes it
        signIn.authClient.tokenManager.clear();
        window.localStorage.removeItem('okta-token-storage');
        window.sessionStorage.removeItem('idToken');
        $("#hiddenAccessTokenField").val('');

        // closes session
        signIn.authClient.session.close()
            .then(function () {               
                // Session closed successfully
                window.location = redirectUri;
            })
            .catch(function (error) {
                // Handle error
                window.location = redirectUri;
                console.log('Error closing user session:', error);
                ClearOktaSessions(error.message);
            });
    }
}

function isTokenNotExist() {
    return ($("#oktaAccessTokenField").val() == null || $("#oktaAccessTokenField").val() == undefined || $("#oktaAccessTokenField").val() == '');
}

function SpinnerSpin() {
    $("#SpinnerContainer").css("z-index", "999999");
    $("#SpinnerContainer i").removeClass("NoDisplay");
}

function SpinnerStop() {
    $("#SpinnerContainer").css("z-index", "-1");
    $("#SpinnerContainer i").addClass("NoDisplay");
}

function ShowUserNotExistsError(message) {
    $("#validationMessageModal").show();
    $("#validationMessageModal").removeClass("fade");
    $(".validationMsg").html(message);
}

//new function for vanish okta session from localstogare if its present and stop spinner  --It will execute if any exception occurs in Okta screen
function ClearOktaSessions(errorMessage) {
    //if (errorMessage != null && errorMessage != '') {
    //    ShowUserNotExistsError("Okta Error: " + errorMessage);
    //}
    signIn.authClient.tokenManager.clear();
    window.localStorage.clear();
    window.sessionStorage.clear();
    $("#hiddenAccessTokenField").val('');
    SpinnerStop();    
}